
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-64b0e079&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubcategoryDetailsBlock.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubcategoryDetailsBlock.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-64b0e079!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubcategoryDetailsBlock.vue"),
  /* scopeId */
  "data-v-64b0e079",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/SubcategoryDetailsBlock.vue
// module id = ./dev/src/components/SubcategoryDetailsBlock.vue
// module chunks = 0